// extracted by mini-css-extract-plugin
module.exports = {"TEIDLogo":"TEIDLogo_TEIDLogo__2CeaH","Link":"TEIDLogo_Link__R6ZiA"};